<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="col-md-12">
        <div class="well-notify"></div>
    </div>
    <div class="well-title">
        @if (!loading) {
            <div class="col-md-12">Edit Document Detail - {{ document.Name }}</div>
        }
    </div>
    <div class="col-md-12 well-content">
        <form #frm="ngForm" class="form-horizontal">
            <div class="form-group">
                <label for="docName" class="col-md-2 control-label"> Name </label>
                <div class="col-md-10">
                    @if (!loading) {
                        <input name="docName" type="text" class="form-control" readonly [value]="document.Name" />
                    }
                </div>
            </div>
            <div class="form-group">
                <label for="docType" class="col-md-2 control-label"> Document Type </label>
                <div class="col-md-10">
                    <input
                        name="docType"
                        type="text"
                        class="form-control"
                        readonly
                        [value]="document.DocumentType.Name" />
                </div>
            </div>
            <div class="form-group">
                <label for="fileType" class="col-md-2 control-label"> File Type </label>
                <div class="col-md-10">
                    <input
                        name="fileType"
                        type="text"
                        class="form-control"
                        readonly
                        [value]="document.Files[0].FileType" />
                </div>
            </div>
            <div class="form-group">
                <label for="docDate" class="col-md-2 control-label"> Archive Date </label>
                <div class="col-md-10">
                    <input
                        name="docDate"
                        type="text"
                        class="form-control"
                        readonly
                        [value]="document.ArchiveDate | date: 'MM/dd/yyyy h:mm:ss a'" />
                </div>
            </div>
            <div class="form-group">
                <label for="docFiles" class="col-md-2 control-label"> Files </label>
                <div class="col-md-10">
                    <span name="docFiles" class="form-control">
                        @if (document.Files && document.Files[0]; as file) {
                            <a style="cursor: pointer" (click)="openDocFile(file.Id)">{{ file.FileType }}</a>
                            @if (downloadingFileId === file.Id) {
                                <nz-icon nzType="loading" nzSpin class="download-spinner" />
                            }
                        }
                    </span>
                </div>
            </div>
        </form>
        <div class="panel panel-default">
            <div class="panel-heading" style="font-weight: bold">Keywords</div>
            <div class="panel-body">
                <nz-table
                    #keywordTable
                    [nzData]="docKeywords"
                    nzTableLayout="fixed"
                    [nzFrontPagination]="false"
                    emptyText="No keywords found"
                    nzBordered="true"
                    [nzLoading]="loading">
                    <thead style="border: 1px solid black">
                        <tr>
                            <th>Name</th>
                            <th>Value</th>
                            @if (document.CanEditKeywordData) {
                                <th style="width: 110px; text-align: center">Required</th>
                            }
                            @if (document.CanEditKeywordData) {
                                <th style="width: 90px"></th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (data of keywordTable.data; track data.MetaDataDefinitionID) {
                            <tr>
                                <td>
                                    {{ data.Name }}
                                    @if (data.Required) {
                                        <span class="text-danger" style="margin-left: 2px" aria-hidden="true">*</span>
                                    }
                                </td>
                                <td>
                                    @if (!document.CanEditKeywordData) {
                                        <input
                                            [id]="`${data.MetaDataDefinitionID}_val`"
                                            [name]="`${data.MetaDataDefinitionID}_val`"
                                            class="form-control"
                                            type="text"
                                            [value]="data.Value"
                                            readonly />
                                    } @else {
                                        @if (data.KeywordType !== 3) {
                                            <input
                                                [id]="`${data.MetaDataDefinitionID}_val`"
                                                [name]="`${data.MetaDataDefinitionID}_val`"
                                                type="text"
                                                maxlength="255"
                                                required
                                                #keyValueMdl="ngModel"
                                                class="form-control"
                                                [(ngModel)]="data.Value" />
                                            @if (keyValueMdl.touched && keyValueMdl.invalid) {
                                                <span class="text-danger"> This value is required </span>
                                            }
                                        } @else {
                                            <nz-date-picker
                                                type="date"
                                                [nzId]="`${data.MetaDataDefinitionID}_val`"
                                                [name]="`${data.MetaDataDefinitionID}_val`"
                                                style="width: 100%"
                                                [nzFormat]="data.DateFormatString"
                                                nzPlaceHolder="choose date"
                                                [(ngModel)]="data.DateValue"
                                                #keyValueDateMdl="ngModel"
                                                required>
                                            </nz-date-picker>
                                            @if (keyValueDateMdl.touched && keyValueDateMdl.invalid) {
                                                <span class="text-danger"> This value is required </span>
                                            }
                                        }
                                    }
                                </td>
                                @if (document.CanEditKeywordData) {
                                    <td style="text-align: center">
                                        @if (data.Required) {
                                            <span class="text-danger" style="font-weight: 600">
                                                <span
                                                    class="fa-solid fa-circle-exclamation"
                                                    style="margin-right: 4px"
                                                    aria-hidden="true"></span
                                                >Yes
                                            </span>
                                        } @else {
                                            <span class="text-muted">No</span>
                                        }
                                    </td>
                                }
                                @if (document.CanEditKeywordData) {
                                    <td style="text-align: center">
                                        @if (!data.Required) {
                                            <button
                                                nz-tooltip="Remove {{ data.Name }}"
                                                nz-button
                                                class="btn btn-default"
                                                (click)="removeKeyword(data.MetaDataDefinitionID!)">
                                                <span class="fa-solid fa-trash"></span>
                                            </button>
                                        }
                                    </td>
                                }
                            </tr>
                        }
                    </tbody>
                </nz-table>
                @if (document.CanEditKeywordData) {
                    <div style="display: flex; width: 70%; align-items: center; gap: 8px">
                        <nz-select
                            nzShowSearch
                            nzSelectOnTab
                            nzAllowClear
                            [nzShowArrow]="false"
                            style="width: 100%"
                            [nzOptions]="selectableKeywords"
                            [(ngModel)]="selectedKeyword"
                            nzPlaceHolder="Click here to add keywords"></nz-select>
                        <button
                            nz-tooltip="Add Keyword"
                            nz-button
                            class="btn btn-default"
                            (click)="addKeyword(selectedKeyword)">
                            <span style="color: green" class="fa-solid fa-plus"></span>
                        </button>
                    </div>
                }
            </div>
        </div>
        <div class="panel panel-default">
            <div class="panel-heading" style="font-weight: bold">Notes</div>
            <div class="panel-body">
                <nz-table
                    #noteTable
                    [nzData]="document.Notes"
                    nzTableLayout="fixed"
                    [nzFrontPagination]="false"
                    emptyText="No notes found"
                    nzBordered="true"
                    [nzLoading]="loading">
                    <thead style="border: 1px solid black">
                        <tr>
                            <th>Date</th>
                            <th>User</th>
                            <th>Note</th>
                            @if (document.CanAddNotes) {
                                <th></th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (data of noteTable.data; track data.ID) {
                            <tr>
                                <td>{{ data.Timestamp + "Z" | date: "MM/dd/yyyy h:mm:ss a" }}</td>
                                <td>{{ data.User }}</td>
                                <td style="vertical-align: middle">
                                    <div class="scrollable">
                                        {{ data.Content }}
                                    </div>
                                </td>
                                @if (document.CanAddNotes) {
                                    <td style="text-align: center">
                                        <button
                                            nz-tooltip="Remove note"
                                            nz-button
                                            class="btn btn-default"
                                            (click)="removeNote(data.ID)">
                                            <span class="fa-solid fa-trash"></span>
                                        </button>
                                    </td>
                                }
                            </tr>
                        }
                    </tbody>
                </nz-table>
                @if (document.CanAddNotes) {
                    <div style="display: flex; width: 100%; align-items: center; gap: 8px; margin-top: 4px">
                        <textarea
                            nz-input
                            style="width: 100%; padding: 8px 11px"
                            maxlength="5000"
                            cols="70"
                            rows="2"
                            [(ngModel)]="currentNote"
                            placeholder="Enter new note"></textarea>
                        <button
                            nz-tooltip="Add Note"
                            nz-button
                            class="btn btn-default"
                            (click)="addNote()"
                            [disabled]="!currentNote.trim().length">
                            <span style="color: green" class="fa-solid fa-plus"></span>
                        </button>
                    </div>
                }
            </div>
        </div>
        <div style="margin-top: 20px">
            @if (document.CanAddNotes || document.CanEditKeywordData) {
                <button class="btn btn-default" (click)="save()">Save</button>
            }
            @if (document.CanAddNotes || document.CanEditKeywordData) {
                <button
                    class="btn btn-default"
                    (click)="reset()"
                    nz-tooltip="Undo all changes since the last successful save">
                    Reset
                </button>
            }
            @if (hasHistory) {
                <button nz-tooltip="Back To Search" class="btn btn-default" (click)="goBack()">Back To Search</button>
            }
        </div>
    </div>
</div>
